import React, { useEffect } from 'react';
import ULinlineTable from 'components/_form/ULinlineTable';
import { getErrorHelperText } from 'consts';
import { FormGroup } from 'react-bootstrap';
import {
  FieldError,
  FieldValues,
  Path,
  PathValue,
  UseFormReturn,
} from 'react-hook-form';
import { FormPatternVerify, FormPatternVerifyEnum } from 'enum/FormVerifyEnum';
import InputEngNumControl from './components/InputEngNumControl';

interface RangeInputProps<T extends FieldValues> {
  startName: Path<T>;
  endName: Path<T>;
  startError: FieldError | undefined;
  endError: FieldError | undefined;
  formReturn: UseFormReturn<T>;
  isDisable?: boolean;
}
const RangeInput = <T extends FieldValues>(props: RangeInputProps<T>) => {
  const { startName, endName, formReturn, startError, endError, isDisable } =
    props;
  const {
    register,
    watch,
    control,
    setValue,
    trigger,
    formState: { submitCount },
  } = formReturn;

  const startNameVal = watch(startName) as string;
  const endNameVal = watch(endName) as string;

  /** 若"訖"無值，則同步"起"欄位的值 */
  const orderNoBeginBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (endNameVal === null || endNameVal.length === 0) {
      setValue(endName, e.target.value as PathValue<T, Path<T>>);
    }
  };

  useEffect(() => {
    // 沒有觸發submit就不觸發trigger
    if (submitCount > 0) {
      trigger();
    }
  }, [startNameVal, endNameVal]);

  return (
    <FormGroup>
      <ULinlineTable>
        <li>
          <InputEngNumControl
            rules={{
              pattern: {
                ...FormPatternVerify[FormPatternVerifyEnum.單據號碼],
              },
              required: endNameVal ? '請輸入開始號碼' : undefined,
            }}
            control={control}
            maxLength={20}
            watchValue={watch}
            {...getErrorHelperText(startError)}
            {...register(startName)}
            value={startNameVal}
            onBlur={orderNoBeginBlur}
            disabled={isDisable}
          />
        </li>
        <li style={{ width: '30px' }}>～</li>
        <li>
          <InputEngNumControl
            rules={{
              pattern: { ...FormPatternVerify[FormPatternVerifyEnum.單據號碼] },
              required: startNameVal ? '請輸入結束號碼' : undefined,
            }}
            control={control}
            maxLength={20}
            watchValue={watch}
            {...getErrorHelperText(endError)}
            {...register(endName)}
            value={endNameVal}
            onBlur={orderNoBeginBlur}
            disabled={isDisable}
          />
        </li>
      </ULinlineTable>
    </FormGroup>
  );
};
export default RangeInput;
